import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SalesSettingsRoutingModule } from './sales-settings-routing.module';
import { SalesSettingsComponent } from './sales-settings.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [SalesSettingsComponent],
  imports: [
    CommonModule,
    SharedModule,
    SalesSettingsRoutingModule
  ]
})
export class SalesSettingsModule { }
